import React from 'react';
import { UserDropdownComponent } from '@leagueplatform/web-common-components';
import {
  EVENT_NAME,
  PRODUCT_AREA,
  SCREEN_NAMES,
} from '@leagueplatform/analytics';
import { getUserOptionAnalyticsProps } from '../../../utilities/analytics-helpers';
import { usePreferredFirstName } from '../../../hooks/use-preferred-first-name.hook';
import { UserSettingsLinksConfig } from '../nav-types.types';

const userBarAnalytics = {
  name: EVENT_NAME.BUTTON_CLICKED,
  props: {
    product_area: PRODUCT_AREA.SETTINGS,
    screen_name: SCREEN_NAMES.HOME_SCREEN,
    detail: 'Open Settings Menu',
  },
};

export const UserDropdown = React.memo(
  ({ userSettingsLinks }: { userSettingsLinks: UserSettingsLinksConfig[] }) => {
    const { data, isLoading } = usePreferredFirstName();

    return (
      <UserDropdownComponent
        userBarProps={{
          buttonProps: {
            loading: isLoading,
          },
          iconProps: {
            tint: '$onSurfaceIconPrimary',
          },
        }}
        label={data.preferredFirstName.toUpperCase()}
        dropdownItemsConfig={userSettingsLinks.map((section) => section.items)}
        userBarAnalyticsProps={userBarAnalytics}
        getDropdownItemAnalyticsProps={getUserOptionAnalyticsProps}
      />
    );
  },
);
